import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-component-image',
  templateUrl: './component-image.component.html',
  styleUrl: './component-image.component.scss'
})
export class ComponentImageComponent {

  @Input() imageFileName: string;
  imageSafeUrl: SafeUrl;
  imageLoadFailed = false;
  showImage: boolean = false;
  fetchingImage: boolean = false;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  fetchComponentImage() {
    if (!this.imageFileName || this.imageLoadFailed) {
      this.showImage = true;
      return;
    }
    if(this.showImage == true) {
      this.showImage = false;
      return;
    }
    if (this.imageSafeUrl) {
      this.showImage = true;
      return;
    }
    this.showImage = true;
    this.fetchingImage = true;
    //@ts-ignore
    this.http.get<Blob>(`components/images/${this.imageFileName}`, { responseType: 'blob' }).subscribe((res: Blob) => {
      this.imageSafeUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      this.imageLoadFailed = false;
      this.fetchingImage = false;
    }, (e: any) => {
      this.imageLoadFailed = true;
      this.fetchingImage = false;
    })
  }

}
